import * as betgalaxy from './StatementCard.styles.betgalaxy';
import * as betprofessor from './StatementCard.styles.betprofessor';
import * as betroyale from './StatementCard.styles.betroyale';
import * as fiestabet from './StatementCard.styles.fiestabet';
import * as goldenrush from './StatementCard.styles.goldenrush';
import * as juicybet from './StatementCard.styles.juicybet';
import * as puntcity from './StatementCard.styles.puntcity';
import * as puntgenie from './StatementCard.styles.puntgenie';
import * as questbet from './StatementCard.styles.questbet';
import * as sterlingparker from './StatementCard.styles.sterlingparker';
import * as vikingbet from './StatementCard.styles.vikingbet';
import * as volcanobet from './StatementCard.styles.volcanobet';
import * as junglebet from './StatementCard.styles.junglebet';
import * as oldgill from './StatementCard.styles.oldgill';
import * as sugarcastle from './StatementCard.styles.sugarcastle';
import * as buffalobet from './StatementCard.styles.buffalobet';
import * as titanbet from './StatementCard.styles.titanbet';
import * as slambet from './StatementCard.styles.slambet';
import * as gigabet from './StatementCard.styles.gigabet';
import * as betstride from './StatementCard.styles.betstride';
import * as goldenbet888 from './StatementCard.styles.goldenbet888';
import * as hyperbet from './StatementCard.styles.hyperbet';
import * as bet777 from './StatementCard.styles.bet777';
import * as chromabet from './StatementCard.styles.chromabet';
import * as bet575 from './StatementCard.styles.bet575';
import * as pyramidbet from './StatementCard.styles.pyramidbet';
import * as magnumbet from './StatementCard.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  pyramidbet,
  magnumbet,
};
